<script>


export default {
	name: 'IconSvgGif',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.3714 4.10333C12.9067 4.10289 12.4612 3.92171 12.1326 3.59956C11.804 3.2774 11.6192 2.84059 11.6187 2.385V1.54851e-07H3.78809C3.48765 -0.000109306 3.19013 0.057814 2.91254 0.170461C2.63494 0.283108 2.38269 0.448273 2.17021 0.65652C1.95773 0.864766 1.78918 1.11201 1.67418 1.38414C1.55919 1.65627 1.5 1.94794 1.5 2.2425V15.7608C1.5009 16.3551 1.74239 16.9248 2.17142 17.3447C2.60044 17.7645 3.18192 18.0002 3.78809 18H13.1886C13.7952 18 14.377 17.7637 14.8059 17.3432C15.2349 16.9226 15.4758 16.3523 15.4758 15.7575V4.10333H13.3714Z"
				:fill="color" />
			<path
				d="M15.4758 4.10333H13.3713C12.9066 4.10289 12.4611 3.92171 12.1325 3.59956C11.8039 3.2774 11.6191 2.84059 11.6187 2.385V0L15.4758 4.10333Z"
				fill="#58B857" />
			<path
				d="M17.1351 14.2166H6.50724C5.75336 14.2166 5.14221 14.8157 5.14221 15.5549V18.6615C5.14221 19.4007 5.75336 19.9999 6.50724 19.9999H17.1351C17.889 19.9999 18.5001 19.4007 18.5001 18.6615V15.5549C18.5001 14.8157 17.889 14.2166 17.1351 14.2166Z"
				fill="#58B857" />
			<path d="M9.18873 17.7809V18.3867H8.54871V17.7809H9.18873Z" fill="#F3F3F6" />
			<path
				d="M11.499 16.0833C11.7053 16.2346 11.8438 16.4583 11.8857 16.7075H11.2313C11.1884 16.6179 11.1191 16.543 11.0324 16.4925C10.9353 16.4358 10.824 16.407 10.7111 16.4091C10.6232 16.4056 10.5355 16.4209 10.4543 16.4542C10.3731 16.4875 10.3003 16.5378 10.2411 16.6016C10.1166 16.7478 10.0531 16.9348 10.0634 17.125C10.0634 17.3633 10.1255 17.5464 10.2496 17.6741C10.3195 17.7405 10.4028 17.7919 10.4941 17.8249C10.5854 17.8579 10.6828 17.8718 10.7799 17.8658C10.9186 17.8681 11.0543 17.8263 11.1667 17.7466C11.2809 17.6624 11.3633 17.5434 11.4013 17.4083H10.6202V16.9725H11.918V17.5833C11.8684 17.7324 11.7899 17.8708 11.6869 17.9908C11.5753 18.1199 11.4368 18.2239 11.2806 18.2958C11.1032 18.376 10.9098 18.4158 10.7145 18.4125C10.4773 18.4185 10.2426 18.3627 10.0345 18.2508C9.84404 18.1459 9.68872 17.989 9.58747 17.7991C9.4801 17.5944 9.42607 17.3668 9.43021 17.1366C9.42551 16.9051 9.47955 16.676 9.58747 16.47C9.68854 16.2806 9.84318 16.1237 10.0328 16.0183C10.238 15.9075 10.4694 15.852 10.7035 15.8575C10.9869 15.8438 11.2669 15.9233 11.499 16.0833Z"
				fill="#F3F3F6" />
			<path d="M12.8835 15.8809V18.3867H12.2656V15.8809H12.8835Z" fill="#F3F3F6" />
			<path
				d="M14.9769 15.8809V16.3634H13.9281V16.9167H14.7381V17.3775H13.9281V18.3909H13.3102V15.885L14.9769 15.8809Z"
				fill="#F3F3F6" />
			<path
				d="M8.09914 12.8692C7.17187 12.8681 6.2829 12.5065 5.62722 11.8636C4.97154 11.2207 4.60269 10.3492 4.60156 9.44003C4.60269 8.5309 4.97154 7.65931 5.62722 7.01646C6.2829 6.3736 7.17187 6.01197 8.09914 6.01086C9.02641 6.01197 9.91537 6.3736 10.5711 7.01646C11.2267 7.65931 11.5956 8.5309 11.5967 9.44003C11.5956 10.3492 11.2267 11.2207 10.5711 11.8636C9.91537 12.5065 9.02641 12.8681 8.09914 12.8692ZM8.09914 6.6117C7.33447 6.61302 6.6015 6.91143 6.0608 7.44156C5.52009 7.97169 5.21573 8.69032 5.21438 9.44003C5.21573 10.1897 5.52009 10.9084 6.0608 11.4385C6.6015 11.9686 7.33447 12.267 8.09914 12.2684C8.86381 12.267 9.59678 11.9686 10.1375 11.4385C10.6782 10.9084 10.9825 10.1897 10.9839 9.44003C10.9825 8.69032 10.6782 7.97169 10.1375 7.44156C9.59678 6.91143 8.86381 6.61302 8.09914 6.6117Z"
				fill="#58B857" />
			<path
				d="M8.09884 11.3616C7.69917 11.3622 7.30555 11.266 6.95294 11.0815C6.60034 10.897 6.29966 10.63 6.07764 10.3041L6.58761 9.9708C6.75346 10.2142 6.97799 10.4137 7.24131 10.5517C7.50462 10.6896 7.79859 10.7617 8.09714 10.7616C8.39579 10.7618 8.68986 10.6896 8.95321 10.5515C9.21655 10.4134 9.44102 10.2136 9.60666 9.96997L10.1166 10.3033C9.89508 10.6289 9.59501 10.8958 9.24302 11.0804C8.89104 11.265 8.49802 11.3616 8.09884 11.3616Z"
				fill="#58B857" />
			<path
				d="M7.1293 8.91417C7.35415 8.91417 7.53642 8.73547 7.53642 8.51501C7.53642 8.29456 7.35415 8.11584 7.1293 8.11584C6.90444 8.11584 6.72217 8.29456 6.72217 8.51501C6.72217 8.73547 6.90444 8.91417 7.1293 8.91417Z"
				fill="#58B857" />
			<path
				d="M9.06912 8.91417C9.29397 8.91417 9.47624 8.73547 9.47624 8.51501C9.47624 8.29456 9.29397 8.11584 9.06912 8.11584C8.84426 8.11584 8.66199 8.29456 8.66199 8.51501C8.66199 8.73547 8.84426 8.91417 9.06912 8.91417Z"
				fill="#58B857" />
		</svg>

	</div>
</template>

<style scoped>

</style>